import React from 'react';

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.instagram.com/neoapps_services/"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="NeoApps on Instagram"
      >
        <i className="uil uil-instagram-alt"></i>
      </a>
      <a
        href="https://x.com/NeoappsServices"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="NeoApps on X"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07l-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
          />
        </svg>
      </a>
      <a
        href="https://www.facebook.com/p/Neoapps-61555786269652/"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="NeoApps on Facebook"
      >
        <i className="ri-facebook-circle-fill"></i>
      </a>
    </div>
  );
};

export default Social;
